import React, { useState } from 'react';
import PageDetails from '../PageDetails/PageDetails'
import TabFirst from '../TabFirst/TabFirst'
import './PageStore.css'

const tabsList = [
  {tabId: 'SOCIAL', displayText: 'Inspection'},
  {tabId: 'GAMES', displayText: 'Machine'},
  {tabId: 'NEWS', displayText: 'Workspace & Quality'},
  {tabId: 'FOOD', displayText: 'Inspection Tool'},
]

const appsList = [
  {
    appId: 0,
    appName: 'Facebook',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/social-facebook.png',
    category: 'SOCIAL',
    categoryDetails:[
      {
        InspectionItem: "Filter Condition",
        Description:"Check for any tears, holes, or damage to the filter material.",
        ActionRequired: "Replace if damaged or excessively dirty.",
      },
      {
        InspectionItem: "Dirt Accumulation",
        Description:"Assess the amount of dirt and debris trapped in the filter.",
        ActionRequired: "Clean or replace if heavily soiled.",
      },
      {
        InspectionItem: "Filter Housing",
        Description:"Inspect the housing for any cracks, leaks, or misalignment.",
        ActionRequired: "Repair or replace if necessary.",
      },
      {
        InspectionItem: "Seal Integrity",
        Description:"Ensure that the seal between the filter and housing is intact and secure.",
        ActionRequired: "Replace seal if damaged or leaking.",
      },
      {
        InspectionItem: "Airflow Restriction",
        Description:"Measure airflow through the filter using appropriate tools.",
        ActionRequired: "Clean or replace if airflow is restricted.",
      },
      {
        InspectionItem: "Installation",
        Description:"Verify proper installation of the filter according to manufacturer's instructions.",
        ActionRequired: "Reinstall correctly if necessary.",
      },
      {
        InspectionItem: "Filter Compatibility",
        Description:"Confirm that the filter is the correct type and size for the specific bike model.",
        ActionRequired: "Replace with appropriate filter if needed.",
      },
      {
        InspectionItem: "Installation",
        Description:"Verify proper installation of the filter according to manufacturer's instructions.",
        ActionRequired: "Reinstall correctly if necessary.",
      },

      {
        InspectionItem: "Maintenance History",
        Description:"Review previous maintenance records to determine when the filter was last inspected or replaced.",
        ActionRequired: "Schedule replacement or cleaning accordingly.",
      }
    ]
  },
  

  {
    appId: 3,
    appName: 'Subway Surfers',
    imageUrl:
      'https://www.kanwalenterprises.com/public/images/products/img-oil-filter-test-rig.jpg',
    category: 'GAMES',
  },
 
  
  {
    appId: 4,
    appName: 'Inshorts',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/news-inshorts.png',
    category: 'NEWS',
    content:"Specializing in crafting, supplying oil filters tailored for testing spin-on filters in compression engines, we offer our expertise from Bengaluru. Our products boast corrosion resistance, superior efficiency, and extended lifespan, earning acclaim in the industry. Our team of tech-savvy experts meticulously designs and develops each product to meet the high standards set since our company's inception. This dedication ensures we consistently meet market demands, providing customers with precise solutions for their industries. As prominent oil filter manufacturers, suppliers, and exporters. Our competitively priced range prioritizes affordability without compromising quality. Reach out with your inquiries today.",
    heading:"Oil Filter",
    features : [
      'Superior quality',
      'High-efficiency',
      'Long running life',
      'Hassle-free performance',
      'Unique design',
      'Reasonable price',
    ],

    specifications : [
      'The specifications are  not fixed for the product and  we provide what our clients ask for.',
    ],

  },
  
  {
    appId: 5,
    appName: 'Zomato',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/food-zomato.png',
    category: 'FOOD',
    imageUrl:""
  },
  
]

// Write your code here
const PageStore = () => {
  const [activeTabId, setActiveTabId] = useState(tabsList[0].tabId);
  const [searchInput, setSearchInput] = useState('');
  

  const getFilteredProjects = () => {
    const filterdata = appsList.filter(
      (eachdetails) => eachdetails.category === activeTabId
    );
    return filterdata;
  };

  const onchangestatus = (tabId) => {
    setActiveTabId(tabId);
  };

  const getinputdetails = (event) => {
    setSearchInput(event.target.value);
  };

  const fliterdataproject = getFilteredProjects();
  const searchresult = fliterdataproject.filter((eachfilterdata) =>
    eachfilterdata.appName.includes(searchInput)
  );

  return (
    <div className="appcontainer">
      <div className="cardcontainer">
        <div className="upcontainer">
         
        </div>
        <ul className="tabitemcontainer">
          {tabsList.map((each) => (
            <TabFirst
              tabname={each}
              key={each.tabId}
              onchangestatus={onchangestatus}
              isActive={activeTabId === each.tabId}
            />
          ))}
        </ul>
        <ul className="appcontainer">
          {searchresult.map((each) => (
            <PageDetails Appitem={each} key={each.appId} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PageStore;
